import React, { useEffect, useState, useMemo } from "react";

const CircularProgressAnalytics = ({
  label,
  value = 0,         // current count
  total = 1,          // max / denominator
  color = "#4caf50",
  radius = 30,
  stroke = 6,
}) => {
  const normalizedRadius = useMemo(
    () => radius - stroke / 2,
    [radius, stroke]
  );

  const circumference = useMemo(
    () => 2 * Math.PI * normalizedRadius,
    [normalizedRadius]
  );

  const [offset, setOffset] = useState(circumference);
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    const safeTotal = total > 0 ? total : 1;
    const clampedValue = Math.max(0, Math.min(value, safeTotal));
    const progress = clampedValue / safeTotal;
    const newOffset = circumference * (1 - progress);

    setOffset(newOffset);
    setDisplayValue(clampedValue);
  }, [value, total, circumference]);

  return (
    <div style={styles.container}>
      <svg style={styles.svg}>
        {/* background circle */}
        <circle
          stroke="#e5e7eb"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        {/* progress circle */}
        <circle
          stroke={color}
          fill="transparent"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          style={{
            transition: "stroke-dashoffset 0.4s ease-out",
          }}
        />
      </svg>

      <span style={styles.value}>{displayValue}</span>
      <span style={styles.label}>{label}</span>
    </div>
  );
};

const styles = {
  container: {
    width: "60px",
    height: "80px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  svg: {
    transform: "rotate(-90deg)",
    width: "60px",
    height: "60px",
  },
  value: {
    position: "absolute",
    top: "30px",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    fontSize: "13px",
    fontWeight: 600,
    color: "#111827",
    lineHeight: "1.2",
  },
  label: {
    width: "60px",
    textAlign: "center",
    fontSize: "11px",
    color: "#6b7280",
  },
};

export default CircularProgressAnalytics;
